import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonNote, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea, IonTitle, IonToolbar, useIonAlert, useIonLoading, useIonRouter, useIonToast, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, locationOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

interface PlaceCreateModalProps {
    insertPlace: React.FormEventHandler<HTMLFormElement>;
    placeTimezone: any;
}

const PlaceCreateModal: React.FC<PlaceCreateModalProps> = ({ insertPlace, placeTimezone }) => {  
    const [loading, setLoading] = useState<boolean>(true);  
    const [infoVisible, setInfoVisible] = useState<boolean>(false);
    const phoneInputRef = useRef<any>();

    const { limits, profiles, timezonesIANA, getTimezonesIANA, userIANATimezone, countries, getCountries } = useAppContext();
    
    useEffect(() => { 
        const effect = async () => {
            if(!timezonesIANA) await getTimezonesIANA(); 
            if(!countries) await getCountries(); 
            setLoading(false);
        }
        effect();
    }, []); 
    

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue;
    };

    const toggleInfoContent = () => setInfoVisible(!infoVisible);

    return (
        <>  
            {/*<div className='ion-text-center'>
                <IonIcon color={'secondary'} icon={locationOutline} style={{'fontSize': '70px'}}></IonIcon> 
            </div>*/}
            <div className='ion-padding-bottom'>
                <h1 className='ion-text-center'>New SoloWise Place</h1>
            </div>
            {/*<div className='ion-padding'>   
                <Alert
                    severity="info"
                    icon={<InfoOutlinedIcon fontSize="inherit" />}
                    sx={{
                    borderRadius: 2,
                    mb: 2
                    }}
                >
                    <AlertTitle>Important:</AlertTitle>
                    <div className='ion-margin-top'>
                        A <strong>SoloWise Place</strong> is a saved location that represents where you plan to be, or where a Route begins or ends. It adds a reference point to your Timers and helps responders orient to your location if an alert is triggered.
                    </div>
                </Alert>
            </div>*/}

            {!loading && profiles?.places >= limits?.places &&
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                            You've reached the limit of Places for your current plan.
                        </IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <p className='ion-margin-bottom ion-text-center'>
                            You can add more Places by upgrading to a SoloWise Premium plan. 
                        </p>
                        <p className='ion-margin-bottom ion-text-center'>                            
                            <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                        </p>
                    </IonCardContent>
                </IonCard>
            } 

            {!loading && profiles?.places < limits?.places &&
            <IonCard>
                <IonCardContent>
                    <form name='placeForm' onSubmit={insertPlace}>
                        <IonGrid>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Name</b> <em className='required'>Required</em></IonLabel><br />
                                    <IonNote>Examples: "Home", "Work", "Some Trailhead"</IonNote>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonInput autoCapitalize='sentences' fill='outline' name='placeName' placeholder='' type='text' maxlength={50}></IonInput>                                        
                                </IonCol>                                  
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Timezone</b> <em className='required'>Required</em></IonLabel>
                                </IonCol>
                                <IonCol sizeXs='12'>
                                    <IonSelect fill='outline' labelPlacement='stacked' name='placeTimezone' placeholder='Timezone of this place' value={userIANATimezone}>
                                        {timezonesIANA.map((zone: any, index: number) => (
                                            <IonSelectOption key={index} value={zone['iana']}>{zone['label']}</IonSelectOption>
                                        ))}                                            
                                    </IonSelect>
                                </IonCol> 
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Address / Location</b></IonLabel> <em className='required'>Required</em><br />
                                    <IonNote>This can be a Street Address, GPS Coordinates, or just a good description.</IonNote>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='placeLocation' placeholder=''></IonTextarea>                               
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Property and Environment</b></IonLabel>
                                </IonCol>
                                <IonCol sizeXs='12' sizeSm='6'>                                           
                                    <IonSelect fill='outline' label='Type of Property' labelPlacement='stacked' name='placePropertyType' placeholder='Select'>
                                        <IonSelectOption value=''>Unknown</IonSelectOption>
                                        <IonSelectOption value='Public'>Public</IonSelectOption> 
                                        <IonSelectOption value='Private'>Private</IonSelectOption>                      
                                    </IonSelect>
                                </IonCol>
                                <IonCol sizeXs='12' sizeSm='6'>
                                    <IonSelect fill='outline' label='Type of Environment' labelPlacement='stacked' name='placeEnvType' placeholder='Select'>
                                        <IonSelectOption value=''>Unknown</IonSelectOption>
                                        <IonSelectOption value='Urban'>Urban</IonSelectOption>
                                        <IonSelectOption value='Suburban'>Suburban</IonSelectOption> 
                                        <IonSelectOption value='Rural'>Rural</IonSelectOption>
                                        <IonSelectOption value='Wilderness'>Wilderness</IonSelectOption>                        
                                    </IonSelect>
                                </IonCol>                               
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Google Maps Link</b></IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonTextarea autoGrow={true} fill='outline' name='placeMapLink' placeholder=''></IonTextarea>                              
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Landline Phone</b></IonLabel>
                                </IonCol>
                                <IonCol sizeXs='12'>
                                    <IonSelect fill='outline' label='Country Code' labelPlacement='stacked' name='placePhoneCode' placeholder='Country Code' value='+1'>
                                        <IonSelectOption value='+1'>+1 (United States / Canada)</IonSelectOption>
                                        {countries.map((country:any, index:number) => (
                                            <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                                        ))}
                                    </IonSelect>
                                </IonCol>
                                <IonCol sizeXs='12'>
                                    <IonInput fill='outline' label='Phone Number' labelPlacement='stacked' name='placePhone' onKeyUp={formatPhone} ref={phoneInputRef} type='tel'></IonInput>  
                                </IonCol> 
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Cellular or Internet connection is available</b></IonLabel>
                                </IonCol>
                                <IonCol className='ion-no-padding' sizeXs='12' sizeSm='6' sizeMd='6' sizeLg='6' sizeXl='6'>
                                    <IonSelect fill='outline' labelPlacement='stacked' name='placeConnectivity' placeholder='Select'>
                                        <IonSelectOption value='Yes'>Yes</IonSelectOption>
                                        <IonSelectOption value='No'>No</IonSelectOption> 
                                        <IonSelectOption value='Unknown'>Unknown</IonSelectOption>                      
                                    </IonSelect>
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Local Emergency Response Agencies</b></IonLabel><br />
                                    <IonNote>Include the name and phone number of the agencies your emergency contact(s) should call. This could be the local police, search and rescue team, etc.</IonNote>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonTextarea autoGrow={true} fill='outline' name='placeNotes' placeholder=''></IonTextarea>                               
                                </IonCol>
                            </IonRow>

                            <IonRow className='ion-margin-bottom'>
                                <IonCol size='12'>
                                    <IonLabel color={'dark'}><b>Other Information</b></IonLabel>
                                </IonCol>
                                <IonCol size='12'>
                                    <IonTextarea autoCapitalize='sentences' autoGrow={true} fill='outline' name='placeOtherInfo' placeholder=''></IonTextarea>                               
                                </IonCol>
                            </IonRow>

                        </IonGrid>
                        
                        <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='placeFormSubmit' type='submit'>Save</IonButton>
                    </form>
                </IonCardContent>
            </IonCard>  
            }          
        </>
    );
};

export default PlaceCreateModal;